import { Edit } from 'react-admin'

import BookForm from './BookForm'

const BookEdit = props => {
  return (
    <Edit undoable={false} {...props}>
      <BookForm permissions={props.permissions} />
    </Edit>
  )
}

export default BookEdit
